import { useQueryWithStore } from "react-admin";

const usePageGetPost = (name, params = {}, defaults = {}) => {
    const { data, loaded } = useQueryWithStore({
        type: "getPost",
        resource: "website",
        payload: {
            method: `${name}Page`,
            ...params,
        },
    });
    return loaded ? data : defaults;
};
export default usePageGetPost;
